import Search from './Search';

export default Search;  


// WEBPACK FOOTER //
// ./src/components/Search/index.js